import { render, staticRenderFns } from "./LangValue.vue?vue&type=template&id=458f185d&scoped=true"
import script from "./LangValue.vue?vue&type=script&lang=js"
export * from "./LangValue.vue?vue&type=script&lang=js"
import style0 from "./LangValue.vue?vue&type=style&index=0&id=458f185d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "458f185d",
  null
  
)

export default component.exports